export default __webpack_public_path__ + "static/media/united company.40b0d8be.png";